if (!customElements.get('tpt-video-item')) {
	customElements.define(
		'tpt-video-item',
		class TptVideoItem extends HTMLElement {
			constructor() {
				super();
				this.isPlaying = false;
				this._endedHandler = null; // track handler to avoid duplicates
				this.addEventListener('click', this.toggleVideo.bind(this));
			}

			connectedCallback() {
				// Remove auto-generated poster (blurry thumbnail) from all videos
				this.querySelectorAll('video').forEach((video) => {
					video.removeAttribute('poster');
				});

				// Pause main video; let preview loop as background
				const main = this.querySelector('.tpt-video-main');
				if (main) {
					main.pause();
					main.muted = true;
					// Force loop=false — Shopify may render loop="false" which browsers still treat as looping
					main.loop = false;
					main.removeAttribute('loop');

					// Guard: add ended listener only once
					if (!this._endedHandler) {
						this._endedHandler = () => this._onVideoEnded();
						main.addEventListener('ended', this._endedHandler);
					}
				}

				const preview = this.querySelector('.tpt-video-preview');
				if (preview) {
					preview.muted = true;
					preview.play().catch(() => {});
				}
			}

			_onVideoEnded() {
				// Double-check we're still considered playing (guard against ghost calls)
				if (!this.isPlaying) return;

				const currentGroup = this.closest('tpt-group-video');
				if (!currentGroup) return;

				const allItems = Array.from(currentGroup.querySelectorAll('tpt-video-item'));
				const currentIndex = allItems.indexOf(this);
				const nextIndex = (currentIndex + 1) % allItems.length;
				const nextItem = allItems[nextIndex];

				// Stop current
				this.setPlayingState(false);

				// Play next — keep muted so browser allows autoplay
				if (nextItem) nextItem.setPlayingState(true, true);
			}

			// autoPlay=true  → keep muted (browser autoplay policy requires it)
			// autoPlay=false → unmute (manual user click)
			setPlayingState(playing, autoPlay = false) {
				const videoMain = this.querySelector('.tpt-video-main');
				const playBtn = this.querySelector('.tpt-play-button');

				if (playing) {
					this.isPlaying = true;
					this.classList.add('loaded');
					if (videoMain) {
						// Always ensure loop is disabled before each play
						videoMain.loop = false;
						videoMain.removeAttribute('loop');
						videoMain.classList.add('active');
						videoMain.muted = autoPlay; // muted when auto, sound when manual click
						videoMain.currentTime = 0;
						videoMain.play().catch(() => {});
					}
					if (playBtn) playBtn.classList.add('active');
				} else {
					this.isPlaying = false;
					this.classList.remove('loaded');
					if (videoMain) {
						videoMain.classList.remove('active');
						videoMain.pause();
						videoMain.muted = true;
					}
					if (playBtn) playBtn.classList.remove('active');

					// Resume preview if exists
					const preview = this.querySelector('.tpt-video-preview');
					if (preview) preview.play().catch(() => {});
				}
			}

			toggleVideo() {
				const videoMain = this.querySelector('.tpt-video-main');
				if (!videoMain) return;

				if (this.isPlaying) {
					this.setPlayingState(false);
					return;
				}

				const currentGroup = this.closest('tpt-group-video');
				// Pause all other videos in the group before playing
				if (currentGroup) {
					currentGroup.querySelectorAll('tpt-video-item').forEach((item) => {
						if (item !== this) item.setPlayingState(false);
					});
				}

				// Manual click → play with sound (autoPlay=false)
				this.setPlayingState(true, false);
			}
		}
	);
}

// Auto-start the first video in each group after DOM + scripts are ready
// Must be muted (autoPlay=true) to satisfy browser autoplay policy
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('tpt-group-video').forEach((group) => {
		const firstItem = group.querySelector('tpt-video-item');
		if (firstItem) {
			// Delay to ensure connectedCallback has run and Swiper has initialized
			setTimeout(() => firstItem.setPlayingState(true, true), 500);
		}
	});
});
